import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const EmailIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "EmailGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.16523 6C4.97351 6 4.00781 6.97507 4.00017 8.17169C3.99996 8.1802 3.99994 8.18871 4.00012 8.19721V16.6144C4.00012 17.8176 4.96881 18.8 6.16523 18.8H17.8348C19.0312 18.8 19.9999 17.8176 19.9999 16.6144V8.19622C20 8.18843 20 8.18063 19.9999 8.17282C19.9928 6.97569 19.0269 6 17.8348 6H6.16523ZM12.2948 13.4269L18.9019 9.19275V16.6144C18.9019 17.2124 18.4207 17.6952 17.8348 17.6952H6.16523C5.57936 17.6952 5.09815 17.2124 5.09815 16.6144V9.19277L11.7052 13.4269C11.7949 13.4845 11.8973 13.5134 12 13.5134C12.1028 13.5134 12.2051 13.4845 12.2948 13.4269ZM12 12.3059L5.13436 7.90611C5.25665 7.44398 5.6742 7.10481 6.16523 7.10481L17.8348 7.1048C18.3258 7.1048 18.7434 7.44397 18.8657 7.9061L12 12.3059Z"
        fill="#696969"
      />
    </svg>
  );
};

export default EmailIcon;
